import * as React from "react"

import Box, { BoxProps } from "../Box"

export default React.forwardRef<HTMLElement, BoxProps>(
    (props, ref) => <Box column ref={ref} {...props} />
)